import { render, staticRenderFns } from "./MarketplaceSettingsEditUser.vue?vue&type=template&id=ffd25370"
import script from "./MarketplaceSettingsEditUser.vue?vue&type=script&lang=js"
export * from "./MarketplaceSettingsEditUser.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceSettingsEditUser.vue?vue&type=style&index=0&id=ffd25370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports